/* eslint-disable max-lines */

const cfl = {
  name: 'CFL',
  link: '/cfl-travel-packages',
  children: [
    {
      text: 'BC Lions',
      link: '/cfl-travel-packages/bc-lions',
      primaryColor: '#F15623',
    },
    {
      text: 'Calgary Stampeders',
      link: '/cfl-travel-packages/calgary-stampeders',
      primaryColor: '#D0202D',
    },
    {
      text: 'Edmonton Eskimos',
      link: '/cfl-travel-packages/edmonton-elks',
      primaryColor: '#2b5134',
    },
    {
      text: 'Hamilton Tiger-Cats',
      link: '/cfl-travel-packages/hamilton-tiger-cats',
      primaryColor: '#000000',
    },
    {
      text: 'Montreal Alouettes',
      link: '/cfl-travel-packages/montreal-alouettes',
      primaryColor: '#183c6e',
    },
    {
      text: 'Ottawa Redblacks',
      link: '/cfl-travel-packages/ottawa-redblacks',
      primaryColor: '#ac1f2d',
    },
    {
      text: 'Saskatchewan Roughriders',
      link: '/cfl-travel-packages/saskatchewan-roughriders',
      primaryColor: '#624871',
    },
    {
      text: 'Toronto Argonauts',
      link: '/cfl-travel-packages/toronto-argonauts',
      primaryColor: '#0d2240',
    },
    {
      text: 'Winnipeg Blue Bombers',
      link: '/cfl-travel-packages/winnipeg-blue-bombers',
      primaryColor: '#002f87',
    },
  ],
}

const fighting = {
  name: 'Fighting',
  link: '#',
  children: [
    {
      text: 'UFC',
      link: '/mixed-martial-arts-travel-packages/ufc-ultimate-fighting-championship',
    },
  ],
}

const golf = {
  name: 'Golf',
  link: '#',
  children: [
    {
      text: 'PGA Tour',
      link: '/pga-tour-travel-packages',
    },
  ],
}

const mlb = {
  name: 'MLB',
  link: '/mlb-travel-packages',
  children: [
    {
      text: 'Arizona Diamondbacks',
      link: '/mlb-travel-packages/arizona-diamondbacks',
      primaryColor: '#A71930',
    },
    {
      text: 'Atlanta Braves',
      link: '/mlb-travel-packages/atlanta-braves',
      primaryColor: '#CE1141',
    },
    {
      text: 'Baltimore Orioles',
      link: '/mlb-travel-packages/baltimore-orioles',
      primaryColor: '#DF4601',
    },
    {
      text: 'Boston Red Sox',
      link: '/mlb-travel-packages/boston-red-sox',
      primaryColor: '#BD3039',
    },
    {
      text: 'Chicago Cubs',
      link: '/mlb-travel-packages/chicago-cubs',
      primaryColor: '#0E3386',
    },
    {
      text: 'Chicago White Sox',
      link: '/mlb-travel-packages/chicago-white-sox',
      primaryColor: '#000000',
    },
    {
      text: 'Cincinnati Reds',
      link: '/mlb-travel-packages/cincinnati-reds',
      primaryColor: '#C6011F',
    },
    {
      text: 'Cleveland Guardians',
      link: '/mlb-travel-packages/cleveland-guardians',
      primaryColor: '#0C2340',
    },
    {
      text: 'Colorado Rockies',
      link: '/mlb-travel-packages/colorado-rockies',
      primaryColor: '#33006F',
    },
    {
      text: 'Detroit Tigers',
      link: '/mlb-travel-packages/detroit-tigers',
      primaryColor: '#0C2340',
    },
    {
      text: 'Houston Astros',
      link: '/mlb-travel-packages/houston-astros',
      primaryColor: '#002D62',
    },
    {
      text: 'Kansas City Royals',
      link: '/mlb-travel-packages/kansas-city-royals',
      primaryColor: '#004687',
    },
    {
      text: 'Los Angeles Angels',
      link: '/mlb-travel-packages/los-angeles-angels',
      primaryColor: '#BA0021',
    },
    {
      text: 'Los Angeles Dodgers',
      link: '/mlb-travel-packages/los-angeles-dodgers',
      primaryColor: '#005A9C',
    },
    {
      text: 'Miami Marlins',
      link: '/mlb-travel-packages/miami-marlins',
      primaryColor: '#00A3E0',
    },
    {
      text: 'Milwaukee Brewers',
      link: '/mlb-travel-packages/milwaukee-brewers',
      primaryColor: '#12284B',
    },
    {
      text: 'Minnesota Twins',
      link: '/mlb-travel-packages/minnesota-twins',
      primaryColor: '#002B5C',
    },
    {
      text: 'New York Mets',
      link: '/mlb-travel-packages/new-york-mets',
      primaryColor: '#002D72',
    },
    {
      text: 'New York Yankees',
      link: '/mlb-travel-packages/new-york-yankees',
      primaryColor: '#003087',
    },
    {
      text: 'Oakland Athletics',
      link: '/mlb-travel-packages/oakland-athletics',
      primaryColor: '#003831',
    },
    {
      text: 'Philadelphia Phillies',
      link: '/mlb-travel-packages/philadelphia-phillies',
      primaryColor: '#E81828',
    },
    {
      text: 'Pittsburgh Pirates',
      link: '/mlb-travel-packages/pittsburgh-pirates',
      primaryColor: '#000000',
    },
    {
      text: 'San Diego Padres',
      link: '/mlb-travel-packages/san-diego-padres',
      primaryColor: '#2F241D',
    },
    {
      text: 'San Francisco Giants',
      link: '/mlb-travel-packages/san-francisco-giants',
      primaryColor: '#000000',
    },
    {
      text: 'Seattle Mariners',
      link: '/mlb-travel-packages/seattle-mariners',
      primaryColor: '#0C2C56',
    },
    {
      text: 'St. Louis Cardinals',
      link: '/mlb-travel-packages/st-louis-cardinals',
      primaryColor: '#C41E3A',
    },
    {
      text: 'Tampa Bay Rays',
      link: '/mlb-travel-packages/tampa-bay-rays',
      primaryColor: '#092C5C',
    },
    {
      text: 'Texas Rangers',
      link: '/mlb-travel-packages/texas-rangers',
      primaryColor: '#003278',
    },
    {
      text: 'Toronto Blue Jays',
      link: '/mlb-travel-packages/toronto-blue-jays',
      primaryColor: '#134A8E',
    },
    {
      text: 'Washington Nationals',
      link: '/mlb-travel-packages/washington-nationals',
      primaryColor: '#BA122B',
    },
  ],
}

const mls = {
  name: 'MLS',
  link: '/mls-travel-packages',
  children: [
    {
      text: 'Atlanta United FC',
      link: '/mls-travel-packages/atlanta-united-fc',
      primaryColor: '#9c2e2a',
    },
    {
      text: 'Chicago Fire',
      link: '/mls-travel-packages/chicago-fire',
      primaryColor: '#121F48',
    },
    {
      text: 'Colorado Rapids',
      link: '/mls-travel-packages/colorado-rapids',
      primaryColor: '#9e2a2f',
    },
    {
      text: 'Columbus Crew SC',
      link: '/mls-travel-packages/columbus-crew-sc',
      primaryColor: '#000000',
    },
    {
      text: 'D.C. United',
      link: '/mls-travel-packages/dc-united',
      primaryColor: '#EE1A39',
    },
    {
      text: 'FC Cincinnati',
      link: '/mls-travel-packages/fc-cincinnati',
      primaryColor: '#FE5000',
    },
    {
      text: 'FC Dallas',
      link: '/mls-travel-packages/fc-dallas',
      primaryColor: '#c8102e',
    },
    {
      text: 'Houston Dynamo',
      link: '/mls-travel-packages/houston-dynamo',
      primaryColor: '#F4911E',
    },
    {
      text: 'Inter Miami CF',
      link: '/mls-travel-packages/inter-miami-cf',
      primaryColor: '#101820',
    },
    {
      text: 'LA Galaxy',
      link: '/mls-travel-packages/los-angeles-galaxy',
      primaryColor: '#000000',
    },
    {
      text: 'Los Angeles FC',
      link: '/mls-travel-packages/los-angeles-fc',
      primaryColor: '#000000',
    },
    {
      text: 'Minnesota United FC',
      link: '/mls-travel-packages/minnesota-united-fc',
      primaryColor: '#00205b',
    },
    {
      text: 'Montreal Impact',
      link: '/mls-travel-packages/cf-montreal',
      primaryColor: '#2B63AD',
    },
    {
      text: 'Nashville SC',
      link: '/mls-travel-packages/nashville-sc',
      primaryColor: '#FFD700',
    },
    {
      text: 'New England Revolution',
      link: 'https://revolution.bookseats.com',
      primaryColor: '#003b5c',
    },
    {
      text: 'New York City FC',
      link: '/mls-travel-packages/new-york-city-fc',
      primaryColor: '#00a9e0',
    },
    {
      text: 'New York Red Bulls',
      link: '/mls-travel-packages/new-york-red-bulls',
      primaryColor: '#e2001a',
    },
    {
      text: 'Orlando City SC',
      link: '/mls-travel-packages/orlando-city-sc',
      primaryColor: '#5c2d91',
    },
    {
      text: 'Philadelphia Union',
      link: '/mls-travel-packages/philadelphia-union',
      primaryColor: '#071b2c',
    },
    {
      text: 'Portland Timbers',
      link: '/mls-travel-packages/portland-timbers',
      primaryColor: '#2a5a3f',
    },
    {
      text: 'Real Salt Lake',
      link: '/mls-travel-packages/real-salt-lake',
      primaryColor: '#9e2a2f',
    },
    {
      text: 'San Jose Earthquakes',
      link: '/mls-travel-packages/san-jose-earthquakes',
      primaryColor: '#0060a9',
    },
    {
      text: 'Seattle Sounders FC',
      link: '/mls-travel-packages/seattle-sounders-fc',
      primaryColor: '#006747',
    },
    {
      text: 'Sporting Kansas City',
      link: '/mls-travel-packages/sporting-kansas-city',
      primaryColor: '#006747',
    },
    {
      text: 'Toronto FC',
      link: '/mls-travel-packages/toronto-fc',
      primaryColor: '#e2001a',
    },
    {
      text: 'Vancouver Whitecaps FC',
      link: '/mls-travel-packages/vancouver-whitecaps-fc',
      primaryColor: '#0060a9',
    },
  ],
}

const motorSports = {
  name: 'Motorsports',
  link: '#',
  children: [
    {
      text: 'FORMULA 1',
      link: '/formula-1-travel-packages/formula-1',
    },
    {
      text: 'NASCAR',
      link: '/motorsportsracing-travel-packages/nascar-cup-series',
    },
  ],
}

const nba = {
  name: 'NBA',
  link: '/nba-travel-packages',
  children: [
    {
      text: 'Atlanta Hawks',
      link: '/nba-travel-packages/atlanta-Hawks',
      primaryColor: '#E03A3E',
    },
    {
      text: 'Boston Celtics',
      link: '/nba-travel-packages/boston-celtics',
      primaryColor: '#008348',
    },
    {
      text: 'Brooklyn Nets',
      link: '/nba-travel-packages/brooklyn-nets',
      primaryColor: '#000000',
    },
    {
      text: 'Charlotte Hornets',
      link: '/nba-travel-packages/charlotte-hornets',
      primaryColor: '#1D1160',
    },
    {
      text: 'Chicago Bulls',
      link: '/nba-travel-packages/chicago-bulls',
      primaryColor: '#CE1141',
    },
    {
      text: 'Cleveland Cavaliers',
      link: '/nba-travel-packages/cleveland-cavaliers',
      primaryColor: '#6F263D',
    },
    {
      text: 'Dallas Mavericks',
      link: '/nba-travel-packages/dallas-mavericks',
      primaryColor: '#00538C',
    },
    {
      text: 'Denver Nuggets',
      link: '/nba-travel-packages/denver-nuggets',
      primaryColor: '#0E2240',
    },
    {
      text: 'Detroit Pistons',
      link: '/nba-travel-packages/detroit-pistons',
      primaryColor: '#1D42BA',
    },
    {
      text: 'Golden State Warriors',
      link: '/nba-travel-packages/golden-state-warriors',
      primaryColor: '#1D428A',
    },
    {
      text: 'Houston Rockets',
      link: '/nba-travel-packages/houston-rockets',
      primaryColor: '#CE1141',
    },
    {
      text: 'Indiana Pacers',
      link: '/nba-travel-packages/indiana-pacers',
      primaryColor: '#002D62',
    },
    {
      text: 'Los Angeles Clippers',
      link: '/nba-travel-packages/los-angeles-clippers',
      primaryColor: '#C8102E',
    },
    {
      text: 'Los Angeles Lakers',
      link: '/nba-travel-packages/los-angeles-lakers',
      primaryColor: '#552583',
    },
    {
      text: 'Memphis Grizzlies',
      link: '/nba-travel-packages/memphis-grizzlies',
      primaryColor: '#5D76A9',
    },
    {
      text: 'Miami Heat',
      link: '/nba-travel-packages/miami-heat',
      primaryColor: '#98002E',
    },
    {
      text: 'Milwaukee Bucks',
      link: '/nba-travel-packages/milwaukee-bucks',
      primaryColor: '#00471B',
    },
    {
      text: 'Minnesota Timberwolves',
      link: '/nba-travel-packages/minnesota-timberwolves',
      primaryColor: '#0C2340',
    },
    {
      text: 'New Orleans Pelicans',
      link: '/nba-travel-packages/new-orleans-pelicans',
      primaryColor: '#0C2340',
    },
    {
      text: 'New York Knicks',
      link: '/nba-travel-packages/new-york-knicks',
      primaryColor: '#006BB6',
    },
    {
      text: 'Oklahoma City Thunder',
      link: '/nba-travel-packages/oklahoma-city-thunder',
      primaryColor: '#007AC1',
    },
    {
      text: 'Orlando Magic',
      link: '/nba-travel-packages/orlando-magic',
      primaryColor: '#0077C0',
    },
    {
      text: 'Philadelphia 76ers',
      link: '/nba-travel-packages/philadelphia-76ers',
      primaryColor: '#006BB6',
    },
    {
      text: 'Phoenix Suns',
      link: '/nba-travel-packages/phoenix-suns',
      primaryColor: '#1D1160',
    },
    {
      text: 'Portland Trail Blazers',
      link: '/nba-travel-packages/portland-trail-blazers',
      primaryColor: '#E03A3E',
    },
    {
      text: 'Sacramento Kings',
      link: '/nba-travel-packages/sacramento-kings',
      primaryColor: '#5A2D81',
    },
    {
      text: 'San Antonio Spurs',
      link: '/nba-travel-packages/san-antonio-spurs',
      primaryColor: '#000000',
    },
    {
      text: 'Toronto Raptors',
      link: '/nba-travel-packages/toronto-raptors',
      primaryColor: '#CE1141',
    },
    {
      text: 'Utah Jazz',
      link: '/nba-travel-packages/utah-jazz',
      primaryColor: '#002B5C',
    },
    {
      text: 'Washington Wizards',
      link: '/nba-travel-packages/washington-wizards',
      primaryColor: '#E31837',
    },
  ],
}

const ncaaB = {
  name: 'NCAAB',
  link: '/college-basketball-travel-packages',
  children: [
    {
      text: 'Alabama Crimson Tide Mens',
      link: '/college-basketball-travel-packages/alabama-crimson-tide-basketball',
      primaryColor: '#9E1B32',
    },
    {
      text: 'Arizona Wildcats Mens',
      link: '/college-basketball-travel-packages/arizona-wildcats-basketball',
      primaryColor: '#CC0033',
    },
    {
      text: 'Auburn Tigers Mens',
      link: '/college-basketball-travel-packages/auburn-tigers-basketball',
      primaryColor: '#0C2340',
    },
    {
      text: 'BYU Cougars Mens',
      link: '/college-basketball-travel-packages/byu-cougars-basketball',
      primaryColor: '#002E5D',
    },
    {
      text: 'Butler Bulldogs Mens',
      primaryColor: '#000000',
      link: '/college-basketball-travel-packages/butler-bulldogs-basketball',
    },
    {
      primaryColor: '#0736A4',
      text: 'Duke Blue Devils Mens',
      link: '/college-basketball-travel-packages/duke-blue-devils-basketball',
    },
    {
      primaryColor: '#0021A5',
      text: 'Florida Gators Mens',
      link: '/college-basketball-travel-packages/florida-gators-basketball',
    },
    {
      primaryColor: '#000000',
      text: 'Gonzaga Bulldogs Mens',
      link: '/college-basketball-travel-packages/gonzaga-bulldogs-basketball',
    },
    {
      primaryColor: '#C8102E',
      text: 'Houston Cougars Mens',
      link: '/college-basketball-travel-packages/houston-cougars-basketball',
    },
    {
      primaryColor: '#E84A27',
      text: 'Illinois Fighting Illini Mens',
      link: '/college-basketball-travel-packages/illinois-fighting-illini-basketball',
    },
    {
      primaryColor: '#990000',
      text: 'Indiana Hoosiers Mens',
      link: '/college-basketball-travel-packages/indiana-hoosiers-basketball',
    },
    {
      primaryColor: '#0051BA',
      text: 'Kansas Jayhawks Mens',
      link: '/college-basketball-travel-packages/kansas-jayhawks-basketball',
    },
    {
      primaryColor: '#512888',
      text: 'Kentucky Wildcats Mens',
      link: '/college-basketball-travel-packages/kansas-state-wildcats-basketball',
    },
    {
      primaryColor: '#000000',
      text: "Louisiana Ragin' Cajuns Mens",
      link: '/college-basketball-travel-packages/louisiana-lafayette-ragin-cajuns-basketball',
    },
    {
      primaryColor: '#00274C',
      text: 'Michigan Wolverines Mens',
      link: '/college-basketball-travel-packages/michigan-wolverines-basketball',
    },
    {
      primaryColor: '#7BAFD4',
      text: 'North Carolina Tar Heels Mens',
      link: '/college-basketball-travel-packages/north-carolina-tar-heels-basketball',
    },
    {
      primaryColor: '#4E2A84',
      text: 'Northwestern Wildcats Mens',
      link: '/college-basketball-travel-packages/northwestern-wildcats-basketball',
    },
    {
      primaryColor: '#CEB888',
      text: 'Purdue Boilermakers Mens',
      link: '/college-basketball-travel-packages/purdue-boilermakers-basketball',
    },
    {
      primaryColor: '#FF8200',
      text: 'Tennessee Volunteers Mens',
      link: '/college-basketball-travel-packages/tennessee-volunteers-basketball',
    },
    {
      primaryColor: '#000E2F',
      text: 'UConn Huskies Mens',
      link: '/college-basketball-travel-packages/uconn-huskies-basketball',
    },
    {
      text: 'Utah Utes',
      primaryColor: '#be2025',
      link: 'https://utes.bookseats.com/',
    },
    {
      primaryColor: '#000000',
      text: 'Villanova Wildcats Mens',
      link: '/college-basketball-tickets/villanova-wildcats-basketball',
    },
    {
      primaryColor: '#000000',
      text: 'All NCAA Basketball tickets',
      link: '/college-basketball-tickets',
    },
  ],
}

const ncaaF = {
  name: 'NCAAF',
  link: '/college-football-travel-packages',
  children: [
    {
      primaryColor: '#9E1B32',
      text: 'Alabama Crimson Tide',
      link: '/college-football-travel-packages/alabama-crimson-tide-football',
    },
    {
      text: 'Arkansas Razorbacks',
      link: '/college-football-travel-packages/arkansas-razorbacks-football',
      primaryColor: '#9D2235',
    },
    {
      text: 'Auburn Tigers',
      link: '/college-football-travel-packages/auburn-tigers-football',
      primaryColor: '#0C2340',
    },
    {
      text: 'Florida Gators',
      link: '/college-football-travel-packages/florida-gators-football',
      primaryColor: '#0021A5',
    },
    {
      text: 'Florida State Seminoles',
      link: '/college-football-travel-packages/florida-state-seminoles-football',
      primaryColor: '#782F40',
    },
    {
      text: 'Georgia Bulldogs',
      link: '/college-football-travel-packages/georgia-bulldogs-football',
      primaryColor: '#BA0C2F',
    },
    {
      text: 'Iowa Hawkeyes',
      link: '/college-football-travel-packages/iowa-hawkeyes-football',
      primaryColor: '#FFE100',
    },
    {
      text: 'LSU Tigers',
      link: '/college-football-travel-packages/lsu-tigers-football',
      primaryColor: '#461D7C',
    },
    {
      text: 'Miami Hurricanes',
      link: '/college-football-travel-packages/miami-hurricanes-football',
      primaryColor: '#F47321',
    },
    {
      text: 'Michigan State Spartans',
      link: '/college-football-travel-packages/michigan-state-spartans-football',
      primaryColor: '#18453B',
    },
    {
      text: 'Michigan Wolverines',
      link: '/college-football-travel-packages/michigan-wolverines-football',
      primaryColor: '#00274C',
    },
    {
      text: 'Nebraska Cornhuskers',
      link: '/college-football-travel-packages/nebraska-cornhuskers-football',
      primaryColor: '#E41C38',
    },
    {
      text: 'New Mexico Lobos',
      link: '/college-football-travel-packages/new-mexico-lobos-football',
      primaryColor: '#BA0C2F',
    },
    {
      text: 'North Carolina Tar Heels',
      link: '/college-football-travel-packages/north-carolina-tar-heels-football',
      primaryColor: '#7BAFD4',
    },
    {
      text: 'Notre Dame Fighting Irish',
      link: '/college-football-travel-packages/notre-dame-fighting-irish-football',
      primaryColor: '#0C2340',
    },
    {
      text: 'Ohio State Buckeyes',
      link: '/college-football-travel-packages/ohio-state-buckeyes-football',
      primaryColor: '#BB0000',
    },
    {
      text: 'Oklahoma Sooners',
      link: '/college-football-travel-packages/oklahoma-sooners-football',
      primaryColor: '#841617',
    },
    {
      text: 'Ole Miss Rebels',
      link: '/college-football-travel-packages/ole-miss-rebels-football',
      primaryColor: '#CE1126',
    },
    {
      text: 'TCU Horned Frogs',
      link: '/college-football-travel-packages/tcu-horned-frogs-football',
      primaryColor: '#4D1979',
    },
    {
      text: 'Tennessee Volunteers',
      link: '/college-football-travel-packages/tennessee-volunteers-football',
      primaryColor: '#FF8200',
    },
    {
      text: 'Texas A&M Aggies',
      link: '/college-football-travel-packages/texas-a-m-aggies-football',
      primaryColor: '#500000',
    },
    {
      text: 'Texas Longhorns',
      link: '/college-football-travel-packages/texas-longhorns-football',
      primaryColor: '#BF5700',
    },
    {
      text: 'USC Trojans',
      link: '/college-football-travel-packages/usc-trojans-football',
      primaryColor: '#990000',
    },
    {
      text: 'Utah Utes',
      primaryColor: '#be2025',
      link: 'https://utes.bookseats.com',
    },
    {
      text: 'Vanderbilt Commodores',
      link: '/college-football-travel-packages/vanderbilt-commodores-football',
      primaryColor: '#866D4B',
    },
    {
      text: 'Wisconsin Badgers',
      link: '/college-football-travel-packages/wisconsin-badgers-football',
      primaryColor: '#C5050C',
    },
    {
      text: 'All NCAA Football tickets',
      link: '/college-football-travel-packages',
      primaryColor: '#000000',
    },
  ],
}

const nfl = {
  name: 'NFL',
  link: '/nfl-travel-packages',
  children: [
    {
      text: 'Super Bowl',
      link: '/package/tickets/BS-935036',
      primaryColor: '#171919',
    },
    {
      text: 'Arizona Cardinals',
      link: '/nfl-travel-packages/arizona-cardinals',
      primaryColor: '#97233F',
    },
    {
      text: 'Atlanta Falcons',
      link: '/nfl-travel-packages/atlanta-falcons',
      primaryColor: '#A71930',
    },
    {
      text: 'Baltimore Ravens',
      link: '/nfl-travel-packages/baltimore-ravens',
      primaryColor: '#241773',
    },
    {
      text: 'Buffalo Bills',
      link: '/nfl-travel-packages/buffalo-bills',
      primaryColor: '#00338D',
    },
    {
      text: 'Carolina Panthers',
      link: '/nfl-travel-packages/carolina-panthers',
      primaryColor: '#0085CA',
    },
    {
      text: 'Chicago Bears',
      link: '/nfl-travel-packages/chicago-bears',
      primaryColor: '#0B162A',
    },
    {
      text: 'Cincinnati Bengals',
      link: '/nfl-travel-packages/cincinnati-bengals',
      primaryColor: '#FB4F14',
    },
    {
      text: 'Cleveland Browns',
      link: '/nfl-travel-packages/cleveland-browns',
      primaryColor: '#311D00',
    },
    {
      text: 'Dallas Cowboys',
      link: '/nfl-travel-packages/dallas-cowboys',
      primaryColor: '#003594',
    },
    {
      text: 'Denver Broncos',
      link: '/nfl-travel-packages/denver-broncos',
      primaryColor: '#FB4F14',
    },
    {
      text: 'Detroit Lions',
      link: '/nfl-travel-packages/detroit-lions',
      primaryColor: '#0076B6',
    },
    {
      text: 'Green Bay Packers',
      link: 'https://packers.bookseats.com',
      primaryColor: '#203731',
    },
    {
      text: 'Houston Texans',
      link: 'https://houstontexans.bookseats.com/',
      primaryColor: '#03202F',
    },
    {
      text: 'Indianapolis Colts',
      link: '/nfl-travel-packages/indianapolis-colts',
      primaryColor: '#002C5F',
    },
    {
      text: 'Jacksonville Jaguars',
      link: '/nfl-travel-packages/jacksonville-jaguars',
      primaryColor: '#006778',
    },
    {
      text: 'Kansas City Chiefs',
      link: '/nfl-travel-packages/kansas-city-chiefs',
      primaryColor: '#E31837',
    },
    {
      text: 'Las Vegas Raiders',
      link: '/nfl-travel-packages/las-vegas-raiders',
      primaryColor: '#000000',
    },
    {
      text: 'Los Angeles Chargers',
      link: '/nfl-travel-packages/los-angeles-chargers',
      primaryColor: '#0080C6',
    },
    {
      text: 'Los Angeles Rams',
      link: '/nfl-travel-packages/los-angeles-rams',
      primaryColor: '#000000', //no color found
    },
    {
      text: 'Miami Dolphins',
      link: '/nfl-travel-packages/miami-dolphins',
      primaryColor: '#008E97',
    },
    {
      text: 'Minnesota Vikings',
      link: '/nfl-travel-packages/minnesota-vikings',
      primaryColor: '#4F2683',
    },
    {
      text: 'New England Patriots',
      link: '/nfl-travel-packages/new-england-patriots',
      primaryColor: '#002244',
    },
    {
      text: 'New Orleans Saints',
      link: '/nfl-travel-packages/new-orleans-saints',
      primaryColor: '#D3BC8D',
    },
    {
      text: 'New York Giants',
      link: '/nfl-travel-packages/new-york-giants',
      primaryColor: '#0B2265',
    },
    {
      text: 'New York Jets',
      link: 'https://newyorkjets.bookseats.com',
      primaryColor: '#125740',
    },
    {
      text: 'Philadelphia Eagles',
      link: '/nfl-travel-packages/philadelphia-eagles',
      primaryColor: '#004C54',
    },
    {
      text: 'Pittsburgh Steelers',
      link: '/nfl-travel-packages/pittsburgh-steelers',
      primaryColor: '#FFB612',
    },
    {
      text: 'San Francisco 49ers',
      link: '/nfl-travel-packages/san-francisco-49ers',
      primaryColor: '#AA0000',
    },
    {
      text: 'Seattle Seahawks',
      link: '/nfl-travel-packages/seattle-seahawks',
      primaryColor: '#002244',
    },
    {
      text: 'Tampa Bay Buccaneers',
      link: '/nfl-travel-packages/tampa-bay-buccaneers',
      primaryColor: '#D50A0A',
    },
    {
      text: 'Tennessee Titans',
      link: '/nfl-travel-packages/tennessee-titans',
      primaryColor: '#0C2340',
    },
    {
      text: 'Washington Commanders',
      link: '/nfl-travel-packages/washington-commanders',
      primaryColor: '#5A1414',
    },
  ],
}

const nhl = {
  name: 'NHL',
  link: '/nhl-travel-packages',
  children: [
    {
      text: 'Anaheim Ducks',
      link: '/nhl-travel-packages/anaheim-ducks',
      primaryColor: '#000000', //no color
    },
    {
      text: 'Boston Bruins',
      link: '/nhl-travel-packages/boston-bruins',
      primaryColor: '#000000',
    },
    {
      text: 'Buffalo Sabres',
      link: '/nhl-travel-packages/buffalo-sabres',
      primaryColor: '#002654',
    },
    {
      text: 'Calgary Flames',
      link: '/nhl-travel-packages/calgary-flames',
      primaryColor: '#C8102E',
    },
    {
      text: 'Carolina Hurricanes',
      link: 'https://hurricanes.bookseats.com',
      primaryColor: '#CC0000',
    },
    {
      text: 'Chicago Blackhawks',
      link: '/nhl-travel-packages/chicago-blackhawks',
      primaryColor: '#CF0A2C',
    },
    {
      text: 'Colorado Avalanche',
      link: '/nhl-travel-packages/colorado-avalanche',
      primaryColor: '#6F263D',
    },
    {
      text: 'Columbus Blue Jackets',
      link: '/nhl-travel-packages/columbus-blue-jackets',
      primaryColor: '#002654',
    },
    {
      text: 'Dallas Stars',
      link: '/nhl-travel-packages/dallas-stars',
      primaryColor: '#006847',
    },
    {
      text: 'Detroit Red Wings',
      link: '/nhl-travel-packages/detroit-red-wings',
      primaryColor: '#CE1126',
    },
    {
      text: 'Edmonton Oilers',
      link: '/nhl-travel-packages/edmonton-oilers',
      primaryColor: '#FF4C00',
    },
    {
      text: 'Florida Panthers',
      link: '/nhl-travel-packages/florida-panthers',
      primaryColor: '#C8102E',
    },
    {
      text: 'Los Angeles Kings',
      link: '/nhl-travel-packages/los-angeles-kings',
      primaryColor: '#000000',
    },
    {
      text: 'Minnesota Wild',
      link: 'https://wild.bookseats.com',
      primaryColor: '#024930',
    },
    {
      text: 'Montreal Canadiens',
      link: '/nhl-travel-packages/montreal-canadiens',
      primaryColor: '#AF1E2D',
    },
    {
      text: 'Nashville Predators',
      link: '/nhl-travel-packages/nashville-predators',
      primaryColor: '#FFB81C',
    },
    {
      text: 'New Jersey Devils',
      link: '/nhl-travel-packages/new-jersey-devils',
      primaryColor: '#CE1126',
    },
    {
      text: 'New York Islanders',
      link: '/nhl-travel-packages/new-york-islanders',
      primaryColor: '#00539B',
    },
    {
      text: 'New York Rangers',
      link: '/nhl-travel-packages/new-york-rangers',
      primaryColor: '#0038A8',
    },
    {
      text: 'Ottawa Senators',
      link: '/nhl-travel-packages/ottawa-senators',
      primaryColor: '#C52032',
    },
    {
      text: 'Philadelphia Flyers',
      link: '/nhl-travel-packages/philadelphia-flyers',
      primaryColor: '#F74902',
    },
    {
      text: 'Pittsburgh Penguins',
      link: '/nhl-travel-packages/pittsburgh-penguins',
      primaryColor: '#000000',
    },
    {
      text: 'San Jose Sharks',
      link: '/nhl-travel-packages/san-jose-sharks',
      primaryColor: '#006D75',
    },
    {
      text: 'Seattle Kraken',
      link: '/nhl-travel-packages/seattle-kraken',
      primaryColor: '#001628',
    },
    {
      text: 'St. Louis Blues',
      link: '/nhl-travel-packages/st-louis-blues',
      primaryColor: '#000000', //no color found
    },
    {
      text: 'Tampa Bay Lightning',
      link: '/nhl-travel-packages/tampa-bay-lightning',
      primaryColor: '#002868',
    },
    {
      text: 'Toronto Maple Leafs',
      link: '/nhl-travel-packages/toronto-maple-leafs',
      primaryColor: '#00205B',
    },
    {
      text: 'Utah Mammoth',
      link: '/nhl-travel-packages/utah-mammoth',
      primaryColor: '#000000', //no color found
    },
    {
      text: 'Vancouver Canucks',
      link: '/nhl-travel-packages/vancouver-canucks',
      primaryColor: '#00205B',
    },
    {
      text: 'Vegas Golden Knights',
      link: 'https://vegasgoldenknights.bookseats.com',
      primaryColor: '#333F42',
    },
    {
      text: 'Washington Capitals',
      link: '/nhl-travel-packages/washington-capitals',
      primaryColor: '#C8102E',
    },
    {
      text: 'Winnipeg Jets',
      link: '/nhl-travel-packages/winnipeg-jets',
      primaryColor: '#041E42',
    },
  ],
}

export const sportsNavigationData = [
  {
    name: 'leagues',
    items: [nfl, mlb, nhl, nba, ncaaF, ncaaB, fighting, golf, motorSports, cfl, mls],
  },
]
